import { Text } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { AuthorResearchPerfEvalWizard } from '@/module/ResearchPerfEval/AuthorResearchPerfEvalWizard';
import {
  getResearchPerfEvalCriteriaOptions,
  getResearchPerfEvalOptions,
} from '@/module/ResearchPerfEval/model/ResearchPerfEvalQuery';

export const Route = createFileRoute(
  '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout/',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { evaluationId, orderNo } = Route.useParams();
  const { data: evaluation } = useSuspenseQuery(getResearchPerfEvalOptions(evaluationId));
  const { data: criteria } = useSuspenseQuery(getResearchPerfEvalCriteriaOptions(evaluationId));
  const index = criteria.map(c => c.orderNo).indexOf(Number(orderNo));
  const template = criteria[index];

  const userId = Route.useSearch().userId;

  return (
    <>
      {userId != null && (
        <AuthorResearchPerfEvalWizard
          key={`${evaluationId}-${orderNo}-${userId}`}
          evaluationId={evaluationId}
          template={template}
          authorId={userId}
          isResearchPerfEvalClosed={!evaluation.open}
        />
      )}
      {userId == null && <Text>Utilizator neselectat</Text>}
    </>
  );
}
